import { SvgIcon } from '@material-ui/core';

export const IconLab = () => {
  const pixelSize = 24;

  return (
    <SvgIcon
      width={pixelSize}
      height={pixelSize}
      viewBox={`0 0 ${pixelSize} ${pixelSize}`}
    >
      <path
        d="M8 1h8v8.474l5.24 9.076c.886 1.533-.221 3.45-1.992 3.45H4.752c-1.77 0-2.877-1.917-1.992-3.45L8 9.474V1zm2 2v7.01l-5.508 9.54a.3.3 0 0 0 .26.45h14.496a.3.3 0 0 0 .26-.45L14 10.01V3h-4z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};
